import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer.js";
import banner3 from "../../assets/banner-x3-lomahuuto.png";
import banner4 from "../../assets/banner-x3-sunholidays.png";
import banner5 from "../../assets/banner-x-lomahuuto.png";
import banner6 from "../../assets/banner-x-sunholidays.png";
import cabin from "../../assets/cabin.jpg"; // Background image
import lake from "../../assets/lake.jpg";

const Layout = ({ children }) => {
  return (
    <div className="relative min-h-screen">
      {/* Background container to ensure background covers everything */}
      {/* <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url(${lake})`, // Apply background image globally
        }}
      ></div> */}

      {/* The main content should be on top of the background */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <NavBar />

        {/* Content container with padding to accommodate the navbar */}
        <div className="flex-grow">
          {/* Children content */}
          <div className="flex-grow min-h-screen bg-slate-100">{children}</div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
